export default __webpack_public_path__ + "static/media/63-min.58a0eb83.jpg";